
import { Button } from "@/components/ui/button";
import { Bug } from "lucide-react";

const SentryErrorTest = () => {
  const triggerError = () => {
    throw new Error("This is an intentional test error for Sentry!");
  };

  return (
    <Button 
      variant="outline" 
      onClick={triggerError}
      className="bg-red-50 hover:bg-red-100 border-red-200 text-red-600"
    >
      <Bug className="h-4 w-4 mr-2" />
      Test Sentry Error
    </Button>
  );
};

export default SentryErrorTest;
